import React from "react";
import { FaInfoCircle } from "react-icons/fa";

import BackButton from "../../components/common/BackButton";


function ToolPageLayout({
  title,
  subtitle,
  steps = [],
  templates = [],
  tips = [],
  onOpenInfo,
  children,
  asideExtra = null,
  guideTitle = "Quick Guide",
  eyebrow = null,
  backLabel = "Back to Smart Tools",
  infoLabel = "Tool Info",
  splitLayout = false,
}) {
  void subtitle;
  void steps;
  void templates;
  void tips;
  void asideExtra;
  void guideTitle;
  void eyebrow;

  return (
    <div className="tool-page-shell">
      <section className="tool-page-main-card tool-page-simple-card">
        <div className="tool-page-topbar">
          <BackButton label={backLabel} />
          {onOpenInfo ? (
            <button onClick={onOpenInfo} className="tool-btn-secondary" type="button">
              <FaInfoCircle /> {infoLabel}
            </button>
          ) : null}
        </div>

        <div className="tool-page-header">
          <h1 className="tool-page-title">{title}</h1>
        </div>

        <div
          className={`tool-page-content${
            splitLayout ? " tool-page-content--split" : ""
          }`}
        >
          {children}
        </div>
      </section>
    </div>
  );
}


export default ToolPageLayout;
